/* eslint-disable import/no-anonymous-default-export */
export default {
  path: "/sale-items",
  shortTitle: "Sale items",
  title: "Sale, clearance and final-sale labels",
  category: "Products and pricing",
  summary: "How marked-down stock is described and why a label cannot remove mandatory remedies.",
  updated: "26 October 2026",
  sections: [
    {
      heading: "A label must be explicit",
      body: [
        "A product is a sale or clearance item only when the product card or detail page visibly says so and shows the payable price. The navigation word “Sale” alone does not make every product final sale. No current catalog entry is coded with a final-sale condition, so customers should not infer one from stock level or category.",
      ],
    },
    {
      heading: "Known condition",
      body: [
        "If a future clearance item has a cosmetic flaw, incomplete packaging or another known limitation, the specific issue should be described and, where useful, photographed before purchase. A generic clearance label is not a substitute for disclosing information likely to affect a buying decision.",
      ],
    },
    {
      heading: "Change of mind and stock",
      body: [
        "A clearly disclosed final-sale term may affect a voluntary change-of-mind request only where lawful and agreed before checkout. Clearance replacement can be unavailable when stock is exhausted; customer care will then consider the available remedy rather than promise a like-for-like replacement.",
      ],
    },
    {
      heading: "Rights preserved",
      body: [
        "Price reduction does not excuse unsafe goods, undisclosed damage, wrong items, false descriptions or lack of title. Mandatory rights and the Parcel Problems and Returns processes remain available. Report a problem with the order number, listing relied on and clear photographs.",
      ],
    },
  ],
};
